import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { MBox } from '../../../../../atoms/MBox';
import { MImageCarousel } from '../../../../../atoms/MImageCarousel';
import { MText } from '../../../../../atoms/MText';
import { MSelect } from '../../../../../atoms/MSelect';

import PriceDetails from '../../../../../molecules/PriceDetails';
import ProductActionButtons from '../../../../../molecules/ProductActionButtons';

import { StyledSlideoutFullpageProductItemCon } from './skins';
import { getSeparatedStyleValueArr } from '../../../../../helpers/style';

export default function SlideoutFullpageProduct(props) {
  const {
    isMobile,
    product,
    selectedVariant,
    theme,
    priceDetailStyles,
    getProductAndSelectedVariantData,
    productActionButtonStyles,
    productImageDimensions,
  } = props;

  const {
    atcButtonWidthStyle,
    variantSelectorWidth,
  } = productActionButtonStyles;

  const bottomBarRef = useRef(null);

  // destructuring curr product item and selected variant data
  // go to function defination for each variable info
  const {
    images,
    offerPrice,
    price,
    off,
    isDiscountDisabled,
    onProductImageClick,
    onProductTitleClick,
    handleVariantChange,
    onAddClick,
    onSkipClick,
    quantityAdded,
    variantOptions,
    showVariantSelector,
    showATCButton,
    showSkipButton,
    // withoutFirstAction,
    isProductAdditionEnabled,
    variantFiller,
    variantFillerStyles,
    variantAtcStatus,
    isMaxQtyAdded,
  } = getProductAndSelectedVariantData(product, selectedVariant);

  const productActionButtonsProps = {
    quantityAdded,
    showVariantSelector: false,
    showATCButton,
    showSkipButton,
    withoutFirstAction: true,
    isProductAdditionEnabled,
    variantFiller,
    variantFillerStyles,
    variantSelectorValue: selectedVariant.title,
    variantSelectorOptions: variantOptions,
    handleVariantChange,
    onAddClick,
    onSkipClick,
    layout: atcButtonWidthStyle === 'fullWidth' ? 'vertical' : 'horizontal',
    isActionsOrderReversed: atcButtonWidthStyle === 'fullWidth',
    variantAtcStatus,
    isMaxQtyAdded,
    ...productActionButtonStyles,
  };

  const bottomBarHeight =
    bottomBarRef && bottomBarRef.current
      ? bottomBarRef.current.getBoundingClientRect().height
      : 0;

  let margin = isMobile
    ? theme.productItemMobileMargin
    : theme.productItemMargin;

  if (bottomBarHeight > 0) {
    margin = getSeparatedStyleValueArr(margin)
      .map((m, i) => `${i === 2 ? m + bottomBarHeight : m}px`)
      .join(' ');
  }

  return (
    <>
      <StyledSlideoutFullpageProductItemCon
        padding={
          isMobile ? theme.productItemMobilePadding : theme.productItemPadding
        }
        margin={margin}
        className={`mr-product-item mr-product-item--cross-sell-popup mr-product-item--${
          theme.popupType
        }-fullpage`}
      >
        <MBox className="mr-product-item__body-wrapper">
          <MImageCarousel
            images={images}
            imageWidth={
              isMobile
                ? productImageDimensions.mobileWidth
                : productImageDimensions.width
            }
            imageHeight={
              isMobile
                ? productImageDimensions.mobileHeight
                : productImageDimensions.height
            }
            imageMobileWidth={productImageDimensions.mobileWidth}
            imageMobileHeight={productImageDimensions.mobileHeight}
            imageIsBordered={theme.isProductImageBordered}
            imageBorderColor={theme.productImageBorderColor}
            imageBorderWidth={theme.productImageBorderWidth}
            imageBorderRadius={
              isMobile
                ? theme.productImageMobileBorderRadius
                : theme.productImageBorderRadius
            }
            imagePadding={theme.productImagePadding}
            imageMargin={theme.productImageMargin}
            arrowColor={productActionButtonStyles.atcButtonBackgroundColor}
            imageIndex={selectedVariant.image_index}
            onImageClick={onProductImageClick}
          />
          <MBox
            padding={theme.productItemBodyPadding}
            margin={theme.productItemBodyMargin}
            className="mr-product-item__body"
          >
            <MBox className="mr-product-body__details">
              <MText
                color={theme.productNameTextColor}
                fontSize={
                  isMobile
                    ? theme.productNameMobileFontSize
                    : theme.productNameFontSize
                }
                mobileFontSize={theme.productNameMobileFontSize}
                fontStyle={theme.productNameFontStyle}
                fontWeight={theme.productNameFontWeight}
                textDecoration={theme.productNameTextDecoration}
                fontFamily={theme.productNameFontFamily}
                textAlignment={
                  isMobile
                    ? theme.productNameMobileTextAlignment
                    : theme.productNameTextAlignment
                }
                padding={
                  isMobile
                    ? theme.productNameMobilePadding
                    : theme.productNamePadding
                }
                margin={
                  isMobile
                    ? theme.productNameMobileMargin
                    : theme.productNameMargin
                }
                className="mr-product-details__product-title"
                onTextClick={onProductTitleClick}
                cursor={theme.isProductTitleClickGoToPage ? 'pointer' : 'auto'}
              >
                {product.title}
              </MText>
              <PriceDetails
                offerPrice={offerPrice}
                price={price}
                off={off}
                isDiscountDisabled={isDiscountDisabled}
                {...priceDetailStyles}
                textAlignment={
                  isMobile
                    ? theme.productPriceMobileTextAlignment
                    : theme.productPriceTextAlignment
                }
                fontFamily={theme.productPriceFontFamily}
                margin={
                  isMobile
                    ? theme.productPriceMobileMargin
                    : theme.productPriceMargin
                }
                padding={
                  isMobile
                    ? theme.productPriceMobilePadding
                    : theme.productPricePadding
                }
                className="mr-product-item__price-con"
              />
              {product.description && (
                <MText
                  color={theme.productDescriptionTextColor}
                  fontSize={
                    isMobile
                      ? theme.productDescriptionMobileFontSize
                      : theme.productDescriptionFontSize
                  }
                  mobileFontSize={theme.productDescriptionMobileFontSize}
                  fontStyle={theme.productDescriptionFontStyle}
                  fontWeight={theme.productDescriptionFontWeight}
                  textDecoration={theme.productDescriptionTextDecoration}
                  fontFamily={theme.productDescriptionFontFamily}
                  textAlignment={
                    isMobile
                      ? theme.productDescriptionMobileTextAlignment
                      : theme.productDescriptionTextAlignment
                  }
                  padding={theme.productDescriptionPadding}
                  margin={theme.productDescriptionMargin}
                  className="mr-product-details__product-description"
                >
                  {product.description}
                </MText>
              )}
              {showVariantSelector && (
                <MSelect
                  className="mr-variant-selector"
                  onChange={handleVariantChange}
                  value={productActionButtonsProps.variantSelectorValue}
                  options={productActionButtonsProps.variantSelectorOptions}
                  style={productActionButtonsProps.variantSelectorStyle}
                  backgroundColor={
                    productActionButtonsProps.variantSelectorBackgroundColor
                  }
                  borderColor={
                    productActionButtonsProps.variantSelectorBorderColor
                  }
                  borderRadius={
                    productActionButtonsProps.variantSelectorBorderRadius
                  }
                  color={productActionButtonsProps.variantSelectorTextColor}
                  fontSize={productActionButtonsProps.variantSelectorFontSize}
                  mobileFontSize={
                    productActionButtonsProps.variantSelectorMobileFontSize
                  }
                  fontStyle={productActionButtonsProps.variantSelectorFontStyle}
                  fontWeight={
                    productActionButtonsProps.variantSelectorFontWeight
                  }
                  textDecoration={
                    productActionButtonsProps.variantSelectorTextDecoration
                  }
                  fontFamily={
                    productActionButtonsProps.variantSelectorFontFamily
                  }
                  textAlignment={
                    productActionButtonsProps.variantSelectorTextAlignment
                  }
                  padding={productActionButtonsProps.variantSelectorPadding}
                  margin={productActionButtonsProps.variantSelectorMargin}
                  width={
                    !variantSelectorWidth || variantSelectorWidth === '0'
                      ? 'auto'
                      : variantSelectorWidth
                  }
                  height={productActionButtonsProps.variantSelectorHeight}
                />
              )}
            </MBox>
            <ProductActionButtons {...productActionButtonsProps} />
          </MBox>
        </MBox>
      </StyledSlideoutFullpageProductItemCon>
      {/* <MBox
        ref={bottomBarRef}
        backgroundColor={theme.offerBackgroundColor}
        padding={theme.bottomBarContainerPadding}
        margin={theme.bottomBarContainerMargin}
        className="mr-popup-widget__bottom-bar-con"
      /> */}
    </>
  );
}

SlideoutFullpageProduct.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isAdminMobileTab: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  product: PropTypes.object.isRequired,
  selectedVariant: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  getProductAndSelectedVariantData: PropTypes.func.isRequired,
  priceDetailStyles: PropTypes.object,
  productActionButtonStyles: PropTypes.object,
  productImageDimensions: PropTypes.object,
};
